export function wrapWithMediaResolution(
  mapping: string,
  camelPlural: string,
  Singular: string
): string {
  const returnPattern = new RegExp(
    `return \\{\\n\\s+${camelPlural}: ([^,]+),\\n\\s+total\\n\\s+\\}`
  )
  const match = mapping.match(returnPattern)
  if (match) {
    const arrayExpr = match[1].trim()
    return mapping.replace(
      match[0],
      `const resolved${Singular}Media = await resolve${Singular}MediaFields(${arrayExpr})\n\n    return {\n      ${camelPlural}: resolved${Singular}Media,\n      total\n    }`
    )
  }
  return mapping.replace(
    new RegExp(`${camelPlural}: (results as ${Singular}\\[\\])`),
    `${camelPlural}: await resolve${Singular}MediaFields($1 as unknown as ${Singular}[])`
  )
}
